import { ReactElement } from 'react';
import { TabContext } from '@mui/lab';

import { TabPanelData } from '~globals/types/commons';

import { AssistantGenerateRoutesDialogTab } from '../../../types';
import { useAssistantGenerateRoutesDialogByItemsContext } from '../../Context';

import AssistantGenerateRoutesDialogByItemsContentFormTab from './Form';
import AssistantGenerateRoutesDialogByItemsContentStepperTab from './Stepper';

import {
  AssistantGenerateRoutesDialogByItemsContentTabsContainer,
  AssistantGenerateRoutesDialogByItemsContentTabsPanel,
} from './styles';

const TABS_PANELS: TabPanelData<AssistantGenerateRoutesDialogTab>[] = [
  {
    id: 'form',
    panel: AssistantGenerateRoutesDialogByItemsContentFormTab,
  },
  {
    id: 'stepper',
    panel: AssistantGenerateRoutesDialogByItemsContentStepperTab,
  },
];

const AssistantGenerateRoutesDialogByItemsContentTabs = (): ReactElement => {
  const {
    activeTab: { tab: currentTab },
  } = useAssistantGenerateRoutesDialogByItemsContext();

  return (
    <AssistantGenerateRoutesDialogByItemsContentTabsContainer dividers>
      <TabContext value={currentTab}>
        {TABS_PANELS.map(({ id, panel: Panel }) => (
          <AssistantGenerateRoutesDialogByItemsContentTabsPanel
            key={`dialog-assistant-generate-routes-by-items-panel-${id}`}
            value={id}
          >
            <Panel />
          </AssistantGenerateRoutesDialogByItemsContentTabsPanel>
        ))}
      </TabContext>
    </AssistantGenerateRoutesDialogByItemsContentTabsContainer>
  );
};

export default AssistantGenerateRoutesDialogByItemsContentTabs;
